import { Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

interface TitleProps extends TypographyProps {}

const Title: FC<TitleProps> = (args) => <Typography {...args} />;

export default Title;
